/** Facebook-style status background gradients (2025 hex codes). */
export interface StatusGradient {
  id: string;
  from: string;
  to: string;
  /** True if text should be dark (#050505) instead of white */
  darkText?: boolean;
}

export const STATUS_GRADIENTS: StatusGradient[] = [
  { id: 'blue', from: '#00C6FF', to: '#0072FF' },
  { id: 'sunset', from: '#FF512F', to: '#DD2476' },
  { id: 'teal', from: '#00C9FF', to: '#92FE9D', darkText: true },
  { id: 'purple', from: '#4A00E0', to: '#8E2DE2' },
  { id: 'autumn', from: '#D7D2CC', to: '#304352' },
];

export function getGradientById(id: string | null | undefined): StatusGradient | null {
  if (!id) return null;
  return STATUS_GRADIENTS.find((g) => g.id === id) ?? null;
}

export function gradientCSS(g: StatusGradient): string {
  return `linear-gradient(135deg, ${g.from}, ${g.to})`;
}
